export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-gradient-to-br from-secondary-50 via-background-50 to-background-100">
      {/* decorative blobs */}
      <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-16 bottom-10 h-64 w-64 rounded-full bg-accent-200/60 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-28 pb-14 md:pt-32 md:pb-20">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          {/* left copy (sparse) */}
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-600"></span>
              </span>
              正在前排 · 今日瓜条持续刷新
            </div>

            <h1 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-foreground-950 sm:text-4xl md:text-[44px]">
              cg51 最新吃瓜现场
              <span className="text-primary-600">直击</span>
            </h1>

            <p className="mt-4 text-base leading-relaxed text-foreground-700 md:text-lg">
              把散落的热点串成一线瓜线。从<b className="font-semibold text-foreground-900">今日热门瓜条</b>到澄清反转，时间线替你理清楚，前排位替你占好——吃瓜现场，少走弯路。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a href="#live" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 shadow-sm hover:bg-primary-600 transition-colors">
                <i className="ri-flashlight-fill"></i>
                去实时吃瓜现场
              </a>
              <a href="#toplist" className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors">
                前排围观今日热榜
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            {/* trust stats row */}
            <dl className="mt-8 grid grid-cols-3 gap-4 border-t border-secondary-200 pt-6">
              <div>
                <dt className="text-xs text-foreground-500">今日瓜条</dt>
                <dd className="mt-1 font-display text-2xl font-bold text-foreground-950">136</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">现场直击</dt>
                <dd className="mt-1 font-display text-2xl font-bold text-foreground-950">24</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">已跟进澄清</dt>
                <dd className="mt-1 font-display text-2xl font-bold text-primary-600">57</dd>
              </div>
            </dl>
          </div>

          {/* right image (against) */}
          <div className="relative">
            <div className="overflow-hidden rounded-2xl border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20a%20vibrant%20live%20entertainment%20gossip%20stage%2C%20center%20a%20large%20glossy%20hot%20chili%20flame%20radar%20with%20bold%20upward%20trending%20graph%20lines%20and%20sparkles%2C%20warm%20coral%20red%20amber%20orange%20and%20deep%20crimson%20palette%20on%20soft%20cream%20paper%20background%2C%20dramatic%20spotlights%20and%20floating%20confetti%20pieces%2C%20clean%20modern%20infographic%20style%2C%20no%20text%2C%20high%20detail%20composition&width=1200&height=860&seq=hero-main&orientation=landscape"
                alt="cg51 今日吃瓜现场热点热度可视化插画"
                title="cg51 吃瓜现场热度可视化"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 left-4 flex items-center gap-2 rounded-xl border border-background-100 bg-background-50 px-3 py-2 shadow-sm">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-500 text-background-50"><i className="ri-fire-fill"></i></span>
              <div>
                <p className="text-xs font-semibold text-foreground-900">热度 TOP1 · 霸榜 6 小时</p>
                <p className="text-[11px] text-foreground-500"># 瓜条仍在持续发酵</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}